import React from 'react';
import PropTypes from 'prop-types';
import LeftComponent from 'components/Authorization/LeftComponent'

function ConfirmEmail({...props}) {
  return (
    <main className="site--width">
      <div className="container_content_signin">
        <LeftComponent />
        <div className="container_global_password">
          <h2 className="password_title">Many thanks for signing up to MedCafe.</h2>
          <p className="password_description">
            To confirm your account, please click on the link in the email that we sent to you.
          </p>
        </div>
      </div>
    </main>
  );
}

ConfirmEmail.defaultProps = {};

ConfirmEmail.propTypes = {};

export default ConfirmEmail;



// WEBPACK FOOTER //
// ./src/components/ConfirmEmail/ConfirmEmail.jsx